import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { withSnackbar } from "notistack";
import React from "react";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckActionPermission } from "Actions/commonAction";
import FlexibleBenefitPlan from "./FlexibleBenefitPlan";
// import LWFBenefits from "./LWFBenefits";
import SalaryCalculations from "./SalaryCalculations";
import SalarySlip from "./SalarySlip";
import VariableComponent from "./VariableComponent";
import LoanSettings from "./LoanSettings";
import ITDeclaration from "./ITDeclaration";
import ITSubmission from "./ITSubmission";
// import MiscSettings from "./MiscSettings";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
  drawerPaper: {
    width: "30%",
  },
});

const MORE_OPTIONS = {
  0: "misc/rounding",
  // -1: "lwfbenefits",
  1: "misc/variable",
  2: "misc/fbp",
  3: "misc/salary_slip",
  4: "misc/loan",
  5: "misc/declaration",
  6: "misc/submission",
};

class MoreOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { readOnly: false, editable: false },
      activeTabValue: 0,
    };
    this.updatePostData = this.updatePostData.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("misc");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.props.history.push(`/config/pay/payroll/misc/rounding`);
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  handleTabChange = (e, activeTabValue) => {
    console.log("activeTabValue: ", activeTabValue);

    this.setState({ activeTabValue }, () => {
      this.props.history.push(
        `/config/pay/payroll/${MORE_OPTIONS[activeTabValue]}`,
      );
    });
  };

  setActiveTabValue = (value) => {
    this.setState({ activeTabValue: value });
  };

  updatePostData() {}

  render() {
    const { classes, activeTabValue, location } = this.props;
    // const { activeTabValue } = this.state;
    console.log("moreoptions", activeTabValue);
    return (
      <IntlProvider locale="en" messages={""}>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div className="innerwrapper-full-width">
            <div className="common-menubar-header-scrollable">
              <Tabs
                value={activeTabValue}
                onChange={this.handleTabChange.bind(this)}
                indicatorColor="#fff"
                textColor="primary"
              >
                <Tab
                  label="Rounding options"
                  className={`tabheading ${
                    location.pathname.includes("rounding")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
                {/* <Tab label="LWF benefits" className={`tabheading ${activeTabValue == 1 ? "active-tab1" : "inactive-tab1"} `} /> */}
                <Tab
                  label="Variable / VPF settings"
                  className={`tabheading ${
                    location.pathname.includes("variable")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
                <Tab
                  label="Flexible benefits plan"
                  className={`tabheading ${
                    location.pathname.includes("fbp")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
                <Tab
                  label="Salary Slip Design"
                  className={`tabheading ${
                    location.pathname.includes("salary_slip")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
                <Tab
                  label="Loan Settings"
                  className={`tabheading ${
                    location.pathname.includes("loan")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
                <Tab
                  label="IT Declaration"
                  className={`tabheading ${
                    location.pathname.includes("declaration")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
                <Tab
                  label="IT Submission"
                  className={`tabheading ${
                    location.pathname.includes("submission")
                      ? "active-tab1"
                      : "inactive-tab1"
                  } `}
                />
              </Tabs>
              <div className="tab-border" />
            </div>
            <main className="content-outer-wrapper">
              <div className={classes.root}>
                <Grid container>
                  <div className="width100">
                    <div>
                      {location.pathname.includes("rounding") && (
                        <SalaryCalculations
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}
                      {/* {activeTabValue == 1 && <LWFBenefits {...this.props} />} */}
                      {location.pathname.includes("variable") && (
                        <VariableComponent
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}
                      {location.pathname.includes("fbp") && (
                        <FlexibleBenefitPlan
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}
                      {location.pathname.includes("salary_slip") && (
                        <SalarySlip
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}
                      {location.pathname.includes("loan") && (
                        <LoanSettings
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}
                      {location.pathname.includes("declaration") && (
                        <ITDeclaration
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}
                      {location.pathname.includes("submission") && (
                        <ITSubmission
                          {...this.props}
                          permissions={this.state.permissions}
                        />
                      )}

                      {/* {activeTabValue == 0 ? (
                      <MiscSettings
                        isedit={true}
                        initData={initData}
                        postData={postData}
                        updatePostData={this.updatePostData}
                        submit={this.submit}
                        {...this.props}
                      />
                    ) : (
                      <SalarySlip
                        postData={postData}
                        updatePostData={this.updatePostData}
                        submit={this.submit}
                      />
                    )} */}
                    </div>
                  </div>
                </Grid>
              </div>
            </main>
          </div>
        )}
      </IntlProvider>
    );
  }
}
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(MoreOptions)));
